module.exports = __webpack_public_path__ + "img/Flag_of_New_Zealand.7d1ea3d5.svg";